import curry from 'lodash.curry';
import createAction from './createAction';

export default (function (type, payloadCreator) {
  return curry(createAction(type, payloadCreator), payloadCreator.length);
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/createCurriedAction.js
// module id = 2753
// module chunks = 0